import { render, staticRenderFns } from "./RuleAdd.vue?vue&type=template&id=630c5ae9&scoped=true"
import script from "./RuleAdd.vue?vue&type=script&lang=js"
export * from "./RuleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c5ae9",
  null
  
)

export default component.exports